import { InjectionToken } from '@angular/core';

/**
 * Configuration options for the SvgIconService
 */
export interface SvgIconConfig {
    /**
     * Path to the icon assets
     */
    iconAssetPath: string;

    /**
     * Object that maps icon names to file paths
     */
    iconFileNamesObject: { [key: string]: string };

    /**
     * Whether to use the IonIcon component
     */
    useIonIconComponent: boolean;
}

/**
 * Injection token for SvgIconService configuration
 */
export const SVG_ICON_CONFIG = new InjectionToken<SvgIconConfig>('SVG_ICON_CONFIG');
